import { default as index4PZzyyUOK2Meta } from "/app/dev/pages/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/dev/pages/index.vue").then(m => m.default || m)
  }
]